import React from 'react';
import { Button, Typography, Container, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import ErrorOutline from "@mui/icons-material/ErrorOutline";

const NotFoundPage = () => {
  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Box sx={{ fontSize: 60, color: 'error.main' }}>
        <ErrorOutline sx={{ fontSize: 60, color: 'error.main' }} />
      </Box>
      <Typography variant="h4" component="h1" sx={{ marginTop: 2, fontWeight: 'bold' }}>
        Oops! page not found
      </Typography>
      <Typography variant="body1" sx={{ marginTop: 1 }}>
        The page you are looking for does not exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ marginTop: 3 }}
        component={Link}
        to="/"
      >
        Go to homepage
      </Button>
    </Container>
  );
};

export default NotFoundPage;
